import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ChatflowNameLabel from 'flow-doctor-lib/components/common/ChatflowNameLabel';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const ExternalTriggerEnrollAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  const chatflowId = diagnosisReason.chatflowId;
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: chatflowId ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.EXTERNAL_TRIGGER_ENROLL.withChatflow_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.EXTERNAL_TRIGGER_ENROLL.withoutChatflow_jsx',
      elements: {
        ObjectNameLabel,
        ChatflowNameLabel,
        b: 'b',
        i: 'i'
      },
      options: {
        objectName: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        },
        chatflowName: {
          portalId: selectedEnrollment.portalId,
          chatflowId
        }
      }
    })
  });
};
export default ExternalTriggerEnrollAnalysisDetails;